<template>
    <div>
        <section class="container mt-3 py-3">
            <h4>Background color <small class="text-dark my-0">(Paleta de colores SIAHE).</small></h4>
            <p class="m-0 p-0">Colores primarios, para uso en botones, titulos.</p>
        
            <div class="row row-colors px-3 mt-3">
                <div class="col-12 col-md-2 bg-primary-sh">.bg-primary-sh</div>
                <div class="col-12 col-md-2 bg-primary-variant">.bg-primary-variant</div>
                <div class="col-12 col-md-2 bg-secondary-sh">.bg-secondary-sh</div>
                <div class="col-12 col-md-2 bg-secondary-variant">.bg-secondary-variant</div>
                <div class="col-12 col-md-2 bg-tertiary">.bg-tertiary</div>
                <div class="col-12 col-md-2 bg-tertiary-variant">.bg-tertiary-variant</div>
            </div>
            <div>
                <code>
                .bg-primary-sh <br>
                .bg-primary-variant <br>
                .bg-secondary-sh <br>
                .bg-secondary-variant <br>
                .bg-tertiary <br>
                .bg-tertiary-variant
                </code>
                <p class="mt-2 mb-0">Ejemplo de uso:</p>
                <div v-highlight><pre class="language-html"><code><script type="text/plain" class="language-markup"><div class="bg-primary-sh"> Background </div></script></code></pre></div>
            </div>
            <hr>

            <div class="mt-5">
                <p class="m-0 p-0">Colores en tono pastel, normalmente usados como fondo (background).</p>
            </div>
            <div class="row row-colors px-3">
                <div class="col-12 col-md-4 bg-siahe text-dark border">.bg-siahe (background)</div>
                <div class="col-12 col-md-4 bg-surface text-dark">.bg-surface</div>
                <div class="col-12 col-md-4 bg-surface-variant text-dark">.bg-surface-variant</div>
            </div>
            <div>
                <code>
                    .bg-siahe <br>
                    .bg-surface <br>
                    .bg-surface-variant
                </code>
                <p class="mt-2 mb-0">Ejemplo de uso:</p>
                <div v-highlight><pre class="language-html"><code><script type="text/plain" class="language-markup"><div class="bg-surface"> Background </div></script></code></pre></div>

            </div>
            <hr>

            <div class="mt-5">
                <p class="m-0 p-0">Colores de estados (status).</p>
            </div>
            <div class="row row-colors px-3">
                <div class="col-12 col-md-4 p-0">
                    <div class="row p-0 m-0">
                        <div class="col-12 bg-sucess-sh">.bg-sucess-sh </div>
                        <div class="col-12 bg-sucess-variant-sh">.bg-sucess-variant-sh </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 py-0">
                    <div class="row p-0 m-0">
                        <div class="col-12 text-dark bg-warning-sh">.bg-warning-sh</div>
                        <div class="col-12 text-dark bg-warning-variant-sh">.bg-warning-variant-sh</div>
                    </div>
                </div>
                <div class="col-12 col-md-4 p-0">
                    <div class="row p-0 m-0">
                        <div class="col-12 bg-danger-sh">.bg-danger-sh</div>
                        <div class="col-12 bg-danger-variant-sh">.bg-danger-variant-sh</div>
                    </div>
                </div>
            </div>
            <div>
                <code>
                    .bg-sucess-sh <br>
                    .bg-sucess-variant-sh <br>
                    .bg-warning-sh <br>
                    .bg-warning-variant-sh <br>
                    .bg-danger-sh <br>
                    .bg-danger-variant-sh
                </code>
                <!-- <p class="m-0 p-0"><span class="me-4">Ejemplo de uso:</span>
                    <code class="text-dark" v-text = "htmlvalue"></code><code>bg-danger-variant-sh</code><code class="text-dark" v-text = "htmlvalue2"> </code>
                </p> -->

                <p class="mt-2 mb-0">Ejemplo de uso:</p>
                <div v-highlight><pre class="language-html"><code><script type="text/plain" class="language-markup"><div class="bg-danger-variant-sh"> Background </div></script></code></pre></div>

            </div>



            <hr>

            <div class="mt-5">
                <p class="m-0 p-0">Escala de grises.</p>
            </div>
            <div class="row row-colors px-3">
                <div class="col-12 col-md-3 bg-gray-strong">.bg-gray-strong</div>
                <div class="col-12 col-md-2 bg-gray-medium">.bg-gray-medium</div>
                <div class="col-12 col-md-2 bg-gray-sh">.bg-gray-sh</div>
                <div class="col-12 col-md-2 bg-gray-hover text-dark">.bg-gray-hover</div>
                <div class="col-12 col-md-3 bg-white-sh border text-dark">.bg-white-sh</div>
            </div>
            <div class="mb-5">
                <code>
                    .bg-gray-strong <br>
                    .bg-gray-medium <br>
                    .bg-gray-sh <br>
                    .bg-gray-hover <br>
                    .bg-white-sh
                </code>
                <!-- <p class="m-0 p-0"><span class="me-4">Ejemplo de uso:</span>
                    <code class="text-dark" v-text = "htmlvalue"></code><code>bg-danger-variant-sh</code><code class="text-dark" v-text = "htmlvalue2"> </code>
                </p> -->

                <p class="mt-2 mb-0">Ejemplo de uso:</p>
                <div v-highlight><pre class="language-html"><code><script type="text/plain" class="language-markup"><div class="bg-gray-strong"> Background </div></script></code></pre></div>
            </div>
            
        </section>

       

    </div>
</template>

<script>
export default({
    created(){
        window.scrollTo(0, 0);
    },
    data: function() {
        return{
            htmlvalue: '<div class="',
            htmlvalue2: '"> Background </div>'
        }
    },
})
</script>
